var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorDiagonalUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70635 15.7073C5.07608 16.3362 4 15.8898 4 14.9994V4H14.9994C15.8898 4 16.3362 5.07608 15.7073 5.70636L12.71 8.71L23.29 19.29L26.2936 16.2927C26.9239 15.6638 28 16.1102 28 17.0006V28H17.0006C16.1102 28 15.6638 26.9239 16.2927 26.2936L19.29 23.29L8.71 12.71L5.70635 15.7073Z",
    fill: "#12131A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2885 22.1169L9.88307 8.7115L12.5888 6H6V12.5888L8.7115 9.88307L22.1169 23.2885L19.4112 26H26V19.4112L23.2885 22.1169ZM23.29 19.29L12.71 8.71L15.7073 5.70636C16.3362 5.07608 15.8898 4 14.9994 4H4V14.9994C4 15.8898 5.07608 16.3362 5.70635 15.7073L8.70989 12.7101L19.29 23.29L16.2927 26.2936C15.6638 26.9239 16.1102 28 17.0006 28H28V17.0006C28 16.1102 26.9239 15.6638 26.2936 16.2927L23.29 19.29Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_183",
    x: 1,
    y: 2.5,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_183",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorDiagonalUpDown);
export default __webpack_public_path__ + "static/media/cursor-diagonal-up-down.e9d16cec89b848fe6b45005f2f611e6e.svg";
export { ForwardRef as ReactComponent };